import "./gateway-api.resource";

import type { SaleResult } from "../../typings/live-api";

export class GatewayApiService {
    public static $inject: string[] = ["$log", "$q", "salesResource", "liveSalesResultsResource"];

    constructor(private $log: ng.ILogService, private $q: ng.IQService, private salesResource, private liveSalesResultsResource) {}

    public countSubscriptions(saleId: number, auctionType: string) {
        return this.salesResource().countSubscriptions({ id: saleId, auctionType }).$promise;
    }

    public fetchLiveSalesResults(saleId: number): Promise<SaleResult[]> {
        return this.liveSalesResultsResource()
            .get({ id: saleId })
            .$promise.then(({ data }) => this.$q.resolve(data))
            .catch(error => {
                this.$log.error("Error while fetching live sales results", error);
                return this.$q.reject(error);
            });
    }
}

angular
    .module("thor.core.gateway-api.service", ["thor.core.gateway-api.resource"])
    .service("gatewayApi", GatewayApiService);
